(() => {
  const container = document.querySelector('.shopify-policy__container');
  const body = container?.querySelector('.shopify-policy__body .rte');
  if (!body) return;
  const isTurkish = document.documentElement.lang.toLowerCase().startsWith('tr');
  if (isTurkish) {
    const titles = {'privacy-policy':'Gizlilik Politikası','refund-policy':'İade Politikası','shipping-policy':'Kargo Politikası','terms-of-service':'Hizmet Şartları'};
    const translatedTitle = titles[location.pathname.split('/').pop()];
    if (translatedTitle) container.querySelector('.shopify-policy__title h1').textContent = translatedTitle;
  }
  const normalize = value => value.replace(/\s+/g, ' ').trim();
  const title = normalize(container.querySelector('.shopify-policy__title h1')?.textContent || '').toLowerCase();
  for (const element of body.querySelectorAll('p,h1,h2,h3,h4,h5,h6')) {
    const text = normalize(element.textContent);
    if (!text && !element.querySelector('img,video,iframe,input,table')) {
      element.setAttribute('data-policy-spacer', '');
      continue;
    }
    if (/^H[1-6]$/.test(element.tagName) && text.toLowerCase() === title) {
      element.setAttribute('data-policy-duplicate-title', '');
      continue;
    }
    if (element.tagName !== 'P' || element.closest('li,td,th') || text.length < 3 || text.length > 150) continue;
    const bold = element.querySelector('b,strong');
    if (!bold || normalize(bold.textContent) !== text || element.querySelector('a')) continue;
    if (/^(title|address|e-?mail|phone|telephone|fax|adres|unvan|ünvan|telefon)\s*:/i.test(text)) continue;
    element.classList.add('policy-subheading');
    element.setAttribute('role', 'heading');
    element.setAttribute('aria-level', '2');
  }
  const headings = [...body.querySelectorAll('h2,h3,.policy-subheading')].filter(element => !element.hasAttribute('data-policy-spacer') && !element.hasAttribute('data-policy-duplicate-title'));
  if (headings.length < 3 || container.querySelector('.policy-contents')) return;
  const nav = document.createElement('nav');
  nav.className = 'policy-contents';
  const label = isTurkish ? 'Bu sayfada' : 'On this page';
  nav.setAttribute('aria-label', label);
  const heading = document.createElement('h2');
  heading.textContent = label;
  nav.append(heading);
  const list = document.createElement('ul');
  headings.forEach((element, index) => {
    if (!element.id) {
      let id = `policy-section-${index + 1}`;
      while (document.getElementById(id)) id += '-section';
      element.id = id;
    }
    const link = document.createElement('a');
    link.href = `#${element.id}`;
    link.textContent = normalize(element.textContent);
    const item = document.createElement('li');
    item.append(link);
    list.append(item);
  });
  nav.append(list);
  container.querySelector('.shopify-policy__body').before(nav);
})();
